import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { Delivery } from "../types";

interface DeliveryInfoProps {
  record?: Delivery;
}

const DeliveryInfo: React.FC<DeliveryInfoProps> = ({ record }) => {
  // Don't render if no delivery data or not delivered
  if (!record || !record.delivered_time) {
    return null;
  }

  const deliveredTime = record.delivered_time
    ? moment(record.delivered_time)
        .tz("Asia/Singapore")
        .format("DD MMMM yyyy - hh:mm A")
    : "";
  const deliveredNote = (record as any).delivered_note || "No note provided";
  const deliveredMedias = (record as any).delivered_medias || [];

  return (
    <Card variant="outlined" style={{ margin: "12px 0" }}>
      <CardContent style={{ padding: "12px 16px" }}>
        <Typography
          variant="h6"
          gutterBottom
          color="primary"
          style={{ fontSize: "1rem", marginBottom: "8px" }}
        >
          Delivery Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Delivered At
            </Typography>
            <Typography variant="body2">{deliveredTime}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Delivery Note
            </Typography>
            <Typography variant="body2">{deliveredNote}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Attachments ({deliveredMedias.length})
            </Typography>
            {deliveredMedias.length > 0 ? (
              <ul style={{ margin: 0, paddingLeft: "16px" }}>
                {deliveredMedias.map((media: any, counter: number) => (
                  <li key={counter}>
                    <a
                      href={media.url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ fontSize: "0.875rem" }}
                    >{`Attachment ${counter + 1}`}</a>
                  </li>
                ))}
              </ul>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No attachments
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DeliveryInfo;
